export default {"src":"/_next/static/media/file_loader.1fa40e7b.svg","height":147,"width":161,"blurWidth":0,"blurHeight":0};